import { Topbar } from './Topbar'
import { Topbar as TopbarAdmin } from '../Admin/Topbar'
import { WelcomeVideo } from '@/components/molecules/Admin/Modals/OnboardingStudent/WelcomeVideo'
import { Calendar } from '@/components/molecules/Admin/Modals/OnboardingStudent/Calendar'
import { Whatsapp } from '@/components/molecules/Admin/Modals/Whatsapp'
import Notification from '@/components/molecules/Admin/Notification'
import { NewJourney } from '@/components/molecules/Admin/Modals/NewJourney'
import { useAppSelector } from '@/store/hooks'
import { useUpdateGoogleCalendar } from '@/utils/hooks/useUpdateGoogleCalendar'
import { useShowWhatsappModal } from '@/utils/hooks/useShowWhatsappModal'
import { useShowModals } from '@/utils/hooks/useShowModals'
import { FeedbackClass } from '@/components/molecules/Admin/Modals/FeedbackClass'

interface CourseProps {
	children: React.ReactNode
}

export function CourseLayout({ children }: CourseProps) {
	const {
		auth: { user },
	} = useAppSelector((state) => state)

	useUpdateGoogleCalendar()

	useShowWhatsappModal()
	useShowModals()

	return (
		<div className='w-full flex flex-col justify-center items-center bg-zinc-950'>
			{(() => {
				if (user?.modo_curso_unico) {
					return <TopbarAdmin />
				}

				return <Topbar />
			})()}
			<div className='flex flex-col w-full min-h-[85vh] overflow-clip relative'>
				{children}
			</div>

			<Notification />

			{/* start of student onboarding */}
			<WelcomeVideo disabledOnClose />
			<Calendar disabledOnClose />
			{/* end of student onboarding */}

			<Whatsapp disabledOnClose />

			<FeedbackClass disabledOnClose />

			{!user?.modo_curso_unico && <NewJourney />}
		</div>
	)
}
